import styled from 'styled-components';
import { Card } from 'antd';

export const DetailContainer = styled.div`
  padding: 24px;
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
`;

export const DetailCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: none;
  margin-bottom: 24px;

  .ant-card-head {
    border-bottom: 1px solid #f0f0f0;
  }

  .ant-card-head-title {
    font-weight: 600;
    color: #262626;
  }

  .ant-descriptions-item-label {
    font-weight: 500;
    color: #595959;
    width: 140px;
  }

  .ant-descriptions-item-content {
    color: #262626;
  }
`;

export const WorkflowCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: none;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);

  .ant-card-head {
    border-bottom: 1px solid #e0f2fe;
    background: rgba(255, 255, 255, 0.8);
  }

  .ant-card-head-title {
    font-weight: 600;
    color: #262626;
  }
`;